import { types, actions } from '.';
import MasterData from '../../../models/masterData';
import { SagaIterator } from 'redux-saga';
import { put, takeLatest, call } from 'redux-saga/effects';
import * as masterDataApi from '../../../api/masterdata';
import { rollbar } from 'src';

export default function* watchMasterData(): SagaIterator {
    yield takeLatest(types.GET_ALL_SPECIALTIES_ASYNC, getAllSpecialtiesAsync);
}

export function* getAllSpecialtiesAsync(): SagaIterator {
    try {
        yield put(actions.actionServerDataRequested());
        const datas: Array<MasterData> = yield call(masterDataApi.getAllPrimarySpecialties);
        yield put(actions.getAllSpecialtiesSucceeded(datas));
    } catch (e) {
        yield put(actions.actionServerDataFailed());
        rollbar.error('Cannot get all specialties!');
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/masterData/saga.ts